import { api } from 'src/api/axios';
import { Application, ApplicationFirstLoad, SubscriptionPlan } from './interfaces/application';
import { ApplicationStateResponse, EstimationResult } from './interfaces/ai';

export const applicationService = {
  getApplications: async (): Promise<ApplicationFirstLoad> => {
    const response = await api.get<ApplicationFirstLoad>(
      '/user/applications/current'
    );
    return response.data;
  },

  getEstimation: async (id: number | string): Promise<any> => {
    const response = await api.post<any>(
      `/user/applications/${id}/estimate`
    );
    return response.data;
  },

  applicationState: async () => {
    const response = await api.get<ApplicationStateResponse>(
      '/user/application-state'
    );
    return response.data;
  },

  getSignUrl: async (id: number |  string) => {
    const response = await api.get<{ signUrl: string; expiresAt: number }>(
      `/user/applications/${id}/sign-url`
    );
    return response.data;
  },

  postSignUrl: async (id: number | string) => {
    const response = await api.get<{ signUrl: string; expiresAt: number }>(
      `/user/applications/${id}/sign`
    );
    return response.data;
  },

  createApplication: async (data: Application): Promise<Application> => {
    const response = await api.post<Application>('/user/applications', data);
    return response.data;
  },

  getActiveSubscriptionPlans: async (): Promise<SubscriptionPlan[]> => {
    const response = await api.get<SubscriptionPlan[]>('/user/subscription-plans/active');
    return response.data;
  },

  updateApplication: async (data: Application): Promise<Application> => {
    const response = await api.patch<Application>('/user/applications', data);
    return response.data;
  },

  updateApplicationById: async (
    id: number | string,
    data: Application
  ): Promise<Application> => {
    const response = await api.patch<Application>(
      `/user/applications/${id}`,
      data
    );
    return response.data;
  },

  submitApplication: async (
    id: number | string,
    data: { paymentMethodId?: string }
  ): Promise<Application> => {
    const response = await api.post<Application>(
      `/user/applications/${id}/submit`,
      {
        paymentMethodId: data.paymentMethodId || '',
      }
    );
    return response.data;
  },

  acceptApplication: async (): Promise<void> => {
    await api.post('/applications/accept');
  },

  rejectApplication: async (): Promise<void> => {
    await api.post('/applications/reject');
  },

  resetAcceptance: async (): Promise<void> => {
    await api.post('/user/application-state/reset-acceptance');
  },
};
